import { render, staticRenderFns } from "./DataTableView.vue?vue&type=template&id=e895cf2a&scoped=true"
import script from "./DataTableView.vue?vue&type=script&lang=js"
export * from "./DataTableView.vue?vue&type=script&lang=js"
import style0 from "./DataTableView.vue?vue&type=style&index=0&id=e895cf2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e895cf2a",
  null
  
)

export default component.exports